export default "__VITE_ASSET__BBYoLMAr__"